export default "__VITE_ASSET__DTIZtJNo__";